<template>
    <div class="el-step pfb-reg"
         :style="style"
         :class="[
      !isSimple && `is-${$parent.direction}`,
      isSimple && 'is-simple',
      isLast && !space && !isCenter && 'is-flex',
      isCenter && !isVertical && !isSimple && 'is-center'
     ]">
        <!-- big -->
        <el-row type="flex" justify="center" v-if="stepType == 'big'">
            <el-col :span="23" style="max-width: 120px;">
                <div class="ovr-step-main" :class="getStatusClass">
                    <div class="ovr-step-submain">
                        <div class="mb-2 mt-1" style="font-size:30px">{{index+1}}</div>
                        <div :style="titleStyle">{{title}}</div>
                    </div>
                </div>
            </el-col>
            <el-col class="ovr-step__line" v-if="!isLast" :span="1"
                    style="width: -webkit-fill-available;"
                    :style="isLast ? '' : { marginRight: $parent.stepOffset + 'px' }">
                <el-row type="flex" justify="center" align="middle" style="height: 120px;">
                    <i class="fas fa-circle"></i>
                </el-row>
            </el-col>
        </el-row>

        <!-- small -->
        <div v-if="stepType == 'small'">
            <div class="el-step__head">
                <div class="el-step__line" :style="getLineStyle">
                    <i class="el-step__line-inner" :style="lineStyle"></i>
                </div>
                <div class="el-step__icon ovr-step-icon" :class="`is-${icon ? 'icon' : 'text'}`"
                     :style="getIconStyle">
                    <slot v-if="currentStatus !== 'success' && currentStatus !== 'error'"
                          name="icon">
                        <i v-if="icon" class="el-step__icon-inner" :class="[icon]" style="color: #fff;"></i>
                        <div class="el-step__icon-inner" v-if="!icon && !isSimple">{{ index + 1 }}</div>
                    </slot>
                    <i v-else style="color: #fff;"
                       :class="[currentStatus === 'success' ? 'fas fa-circle' : '']"
                       class="el-step__icon-inner is-status ">
                    </i>
                </div>
                <div v-if="currentStatus === 'process'"
                     style="width: 40px;margin-left: -10px;">
                    <div style="border: 1px solid #fff; width:0px;height:10px;margin-left:auto;margin-right:auto"></div>
                    <div style="color:#fff; font-size:14px">{{index + 1}} {{ $tc('of') }} {{stepsCount}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .ovr-step__line {
        float: left;
        color: #354656;
    }

    .ovr-step-main {
        float: left;
        width: 80%;
        height: initial;
        padding: 5px;
        border-radius: 50%;
        color: white;
        width: 110px;
        height: 110px;
        text-align: center;
        white-space: normal;
        word-break: break-word;
    }

    .ovr-step-submain {
        /*border: 1px solid #fff;*/
        border-radius: 50%;
        padding: 10px;
        width: 88px;
        height: 88px;
    }

    .ovr-is-process {
        background-color: #123e8e;
    }

    .ovr-is-wait {
        background-color: #354656;
    }

    .ovr-step-icon {
        font-size: 6px;
        width: 18px;
        height: 18px;
        margin: 3px 0px;
        border: 3px solid #fff;
        border-radius: 50%;
        background-color: inherit;
    }

    .el-step__icon.is-icon {
        width: 18px;
    }
</style>
<script>
    export default {
        name: 'ElStep',

        props: {
            title: String,
            icon: String,
            description: String,
            status: String,
            titleSize: {
                type: Number,
                default: 18
            },
            stepType: {
                type: String,
                default: "big"
            }
        },

        data()
        {
            return {
                index: -1,
                lineStyle: {},
                internalStatus: ''
            };
        },

        beforeCreate()
        {
            this.$parent.steps.push(this);
        },

        beforeDestroy()
        {
            const steps = this.$parent.steps;
            const index = steps.indexOf(this);
            if (index >= 0)
            {
                steps.splice(index, 1);
            }
        },

        computed: {
            currentStatus()
            {
                return this.status || this.internalStatus;
            },
            prevStatus()
            {
                const prevStep = this.$parent.steps[this.index - 1];
                return prevStep ? prevStep.currentStatus : 'wait';
            },
            isCenter()
            {
                return this.$parent.alignCenter;
            },
            isVertical()
            {
                return this.$parent.direction === 'vertical';
            },
            isSimple()
            {
                return this.$parent.simple;
            },
            isLast()
            {
                const parent = this.$parent;
                return parent.steps[parent.steps.length - 1] === this;
            },
            stepsCount()
            {
                return this.$parent.steps.length;
            },
            space()
            {
                const {isSimple, $parent: {space}} = this;
                return isSimple ? '' : space;
            },
            style: function ()
            {
                const style = {};
                const parent = this.$parent;
                const len = parent.steps.length;

                const space = (typeof this.space === 'number'
                    ? this.space + 'px'
                    : this.space
                        ? this.space
                        : 100 / (len - (this.isCenter ? 0 : 1)) + '%');
                style.flexBasis = space;
                if (this.isVertical) return style;
                if (this.isLast)
                {
                    style.maxWidth = 100 / this.stepsCount + '%';
                } else
                {
                    style.marginRight = -this.$parent.stepOffset + 'px';
                }

                return style;
            },
            getStatusClass()
            {
                if (this.currentStatus === "process")
                {
                    return "ovr-is-process";
                } else
                {
                    return "ovr-is-wait";
                }
            },
            titleStyle()
            {
                return {'font-size': this.titleSize + "px"};
            },

            getIconStyle()
            {
                if (this.currentStatus === 'success')
                {
                    return {
                        //'border': 'none',
                        //'background-color': 'initial',
                        //'font-size': '11px',
                        //'color': '#009ee0'
                    };
                }
                else
                {
                    return {};
                }
            },
            getLineStyle()
            {
                if (this.currentStatus === 'success')
                {
                    return {
                        'background-color': '#fff',
                        'margin-left': '15px',
                    }
                } else
                {
                    return {
                        'background-color': '#fff',
                        'margin-left': '15px',
                    }
                }
            }
        },

        methods: {
            updateStatus(val)
            {
                const prevChild = this.$parent.$children[this.index - 1];

                if (val > this.index)
                {
                    this.internalStatus = this.$parent.finishStatus;
                } else if (val === this.index && this.prevStatus !== 'error')
                {
                    this.internalStatus = this.$parent.processStatus;
                } else
                {
                    this.internalStatus = 'wait';
                }

                if (prevChild) prevChild.calcProgress(this.internalStatus);
            },

            calcProgress(status)
            {
                let step = 100;
                const style = {};

                style.transitionDelay = 150 * this.index + 'ms';
                if (status === this.$parent.processStatus)
                {
                    step = this.currentStatus !== 'error' ? 0 : 0;
                } else if (status === 'wait')
                {
                    step = 0;
                    style.transitionDelay = (-150 * this.index) + 'ms';
                }

                style.borderWidth = step ? '1px' : 0;
                this.$parent.direction === 'vertical'
                    ? style.height = step + '%'
                    : style.width = step + '%';

                this.lineStyle = style;
            }
        },

        mounted()
        {
            const unwatch = this.$watch('index', val =>
            {
                this.$watch('$parent.active', this.updateStatus, {immediate: true});
                unwatch();
            });
        }
    };
</script>
